var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "nav",
    {
      staticClass: "top-menu d-sm-flex flex-column align-items-start",
      class: { "top-menu-fixed": _vm.isFixed },
    },
    [
      _c("div", {}, [
        _c(
          "div",
          {
            staticClass: "menu-selection d-none d-sm-flex flex-row",
            class: { "cursor-pointer": !_vm.isStatic },
            on: {
              click: function ($event) {
                $event.preventDefault()
                !_vm.isStatic && _vm.toggleMenu()
              },
            },
          },
          [
            !_vm.isStatic
              ? _c(
                  "div",
                  { staticClass: "menu-icon d-flex align-items-center mr-3" },
                  [
                    _c("img", {
                      attrs: {
                        alt: "Menu",
                        src: [
                          _vm.showModulesMenu
                            ? _vm.menuCloseIcon
                            : _vm.menuIcon,
                        ],
                      },
                    }),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "menu-title" }, [
              _c("h1", [_vm._v(_vm._s(_vm.currentModuleName))]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "menu-modules",
            class: { "menu-open": _vm.showModulesMenu },
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "menu-icon d-flex d-md-none align-items-center mr-3 mt-3",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.toggleTopMenu()
                  },
                },
              },
              [_c("img", { attrs: { alt: "Menu", src: _vm.menuCloseIcon } })]
            ),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "menu-list d-flex flex-wrap pt-sm-3" },
              _vm._l(_vm.sortedModules, function (item, idx) {
                return _c(
                  "li",
                  { key: `module-${idx}` },
                  [
                    item.route
                      ? [
                          _c(
                            "router-link",
                            {
                              class: {
                                active: _vm.currentApplicationCode == item.code,
                              },
                              attrs: {
                                to: {
                                  name: item.route,
                                  params: {
                                    code: item.code,
                                    appCode: _vm.formatRouteAppCode(item.code),
                                    title: item.name,
                                  },
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(item.name) +
                                  "\n                        "
                              ),
                            ]
                          ),
                        ]
                      : item.url
                      ? [
                          _c(
                            "a",
                            {
                              attrs: { href: item.url, target: "_blank" },
                              on: { click: _vm.toggleMenu },
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(item.name) +
                                  "\n                        "
                              ),
                            ]
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                )
              }),
              0
            ),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }